import Index from '@/views/buyer/vis/Index.vue';
import List from '@/views/buyer/vis/List.vue';
import { auths, actors } from '@/router/options';

const routes: any[] = [
  {
    path: 'vis',
    redirect: { name: 'buyer-vis-list' },
    component: Index,
    children: [
      {
        name: 'buyer-vis-list',
        path: '',
        component: List,
        meta: {
          title: '予約展示会',
          actor: actors.buyer,
          auth: auths.required,
        },
      },
    ],
  },
];

export default {
  routes,
};
